<template>
  <div
    v-click-outside="closePanel"
    class="soha-icon-menu"
  >
    <div @click.stop="!doNotOpen && handlePanelVisibility()">
      <slot name="activator" />
    </div>

    <transition name="panel">
      <div
        v-if="isOpen"
        class="soha-menu-panel"
        :style="panelStyle"
        @click="handleClickInside"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
import "@/assets/css/components/base/menu.css";

export default {
  name: "Menu",

  props: {
    borderColor: {
      type: String,
      default: "white",
    },
    closeByClickItem: {
      type: Boolean,
      default: true,
    },
    doNotOpen: {
      type: Boolean,
      default: false,
    },
  },

  emits: ['close'],

  data() {
    return {
      isOpen: false,
      menuId: `soha-menu-${Math.random().toString(36).slice(2, 9)}`,
    };
  },

  computed: {
    panelStyle() {
      return {
        border: `1px solid var(--${this.borderColor}-color)`,
      };
    },
  },

  methods: {
    handlePanelVisibility() {
      this.isOpen = !this.isOpen;
      if (this.isOpen) {
        document.dispatchEvent(new CustomEvent("soha-menu-open", { detail: this.menuId }));
      }
    },

    handleClickInside() {
      if (this.closeByClickItem) {
        this.closePanel();
      }
    },

    closePanel() {
      this.isOpen = false;
      this.$emit("close");
    },

    onOtherMenuOpen(e) {
      const otherId = e && e.detail;
      if (otherId && otherId !== this.menuId) {
        this.closePanel();
      }
    },
  },

  mounted() {
    document.addEventListener("soha-menu-open", this.onOtherMenuOpen);
  },

  beforeUnmount() {
    document.removeEventListener("soha-menu-open", this.onOtherMenuOpen);
  },
};
</script>
